import { validateIban } from '@/utils/validators';

export const PAYMENT = {
  ID: 'payment',
  TITLE: 'Forma de pago',
  DESC: 'Completa tus datos personales y bancarios para poder confirmar la oferta',
  BANK_ACCOUNT: {
    NAME: 'iban',
    ID: 'iban',
    LABEL: 'Cuenta bancaria (IBAN)',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        IBAN_IS_VALID: {
          checkFunc: validateIban,
          message: 'IBAN no válido. Ejemplo válido: ES + 22 dígitos',
        },
      },
    },
    MASK: { maxLength: 24, separationLength: 4, separator: ' ' },
  },
};
